import React, { useState, useCallback, useEffect } from 'react';
import { Card, Input, Table, message, Image } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';




// 反作弊查询
const QueryInfo = () => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const columns = [
    { title: '防伪码', dataIndex: 'anti_cheat_code', key: 'anti_cheat_code', width: 160 },
    { title: '所属店铺', dataIndex: 'shop_id', key: 'shop_id', width: 120 }, // 如需店铺名，可后续在后端 join 返回
    { title: '被查证人', dataIndex: 'checked_person', key: 'checked_person', width: 120 },
    { title: '价格', dataIndex: 'price', key: 'price', width: 100, render: v => (v != null ? Number(v).toFixed(2) : '-') },
    { title: '此次被查机器码', dataIndex: 'machine_code', key: 'machine_code', width: 180 },
    { title: 'pc装机时间', dataIndex: 'pc_setup_date', key: 'pc_setup_date', width: 160 },
    { title: '游戏日志时间', dataIndex: 'game_log_date', key: 'game_log_date', width: 160 },
    { title: '开始查证时间', dataIndex: 'start_check_time', key: 'start_check_time', width: 180 },
    { title: '结束查证时间', dataIndex: 'end_check_time', key: 'end_check_time', width: 180 },
    { title: '结果', dataIndex: 'result', key: 'result', width: 120 },
    { title: '备注事宜补充', dataIndex: 'remarks', key: 'remarks', width: 200, ellipsis: true },
    {
      title: '工作区域整体图',
      dataIndex: 'work_area_image',
      key: 'work_area_image',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    {
      title: '主机背板一',
      dataIndex: 'host_back_image',
      key: 'host_back_image',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    {
      title: '主机接口详情图二',
      dataIndex: 'host_interface_image',
      key: 'host_interface_image',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    {
      title: '主机内部硬件图一',
      dataIndex: 'host_internal_image1',
      key: 'host_internal_image1',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    {
      title: '主机内部硬件图二',
      dataIndex: 'host_internal_image2',
      key: 'host_internal_image2',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    {
      title: '系统日志详情图',
      dataIndex: 'system_log_image',
      key: 'system_log_image',
      width: 180,
      render: (url) => url
        ? <Image src={url} width={120} height={80} style={{ objectFit: 'cover' }} preview={{ mask: '预览' }} />
        : '-'
    },
    { title: '师傅接单分润', dataIndex: 'master_share', key: 'master_share', width: 140 },
    { title: '被查证人微信号', dataIndex: 'wechat_id', key: 'wechat_id', width: 160 },
  ];



  const loadData = useCallback(async (page = pagination.current, pageSize = pagination.pageSize, codeOverride = code) => {
    try {
      setLoading(true);
      const res = await axios.get('/api/anti-cheat-records', {
        params: {
          page,
          per_page: pageSize,
          code: (codeOverride && codeOverride.trim()) || undefined, // 按防伪码模糊
        },
      });
      if (res.data?.success) {
        setDataSource(res.data.data);
        setPagination(prev => ({ ...prev, current: page, pageSize, total: res.data.total || 0 }));
      } else {
        throw new Error(res.data?.message || '加载失败');
      }
    } catch (e) {
      message.error(e.message || '加载失败');
      setDataSource([]);
      setPagination(prev => ({ ...prev, total: 0 }));
    } finally {
      setLoading(false);
    }
  }, [code, pagination.current, pagination.pageSize]);

  useEffect(() => {
    // 初次进入不查，按需可自动查
  }, []);

  return (
    <Card title="反作弊查询记录">
      <div style={{ marginBottom: 16 }}>
        <Input.Search
          placeholder="请输入防伪码"
          allowClear
          enterButton={<SearchOutlined />}
          size="large"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onClear={() => {
            setCode('');
            setPagination(prev => ({ ...prev, current: 1 }));
            loadData(1, pagination.pageSize, '');
          }}
          onSearch={() => loadData(1, pagination.pageSize, code)}
          style={{ width: 480 }}
        />
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        size='small'
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: t => `共 ${t} 条记录`,
          onChange: (p, ps) => loadData(p, ps, code),
        }}
        scroll={{ x: 2200 }}
      />
    </Card>
  );
};

export default QueryInfo;